import React, { useState, useEffect } from "react";
import { subscribe, getActiveCount } from "./loaderStore";
import FullscreenLoader from "../components/FullscreenLoader";

export default function LoaderProvider({ children }) {
  const [isVisible, setIsVisible] = useState(getActiveCount() > 0);

  useEffect(() => {
    const unsubscribe = subscribe((count) => {
      setIsVisible(count > 0);
    });
    return unsubscribe;
  }, []);

  return (
    <>
      {children}
      {isVisible && <FullscreenLoader />}
    </>
  );
}
